import * as THREE from 'three'

export default class NineSliceMesh extends THREE.Mesh {
  constructor(texture, options) {
    const geometry = NineSliceMesh.createGeometry(options);

    const material = new THREE.MeshBasicMaterial({
      map: texture,
      color: '#ffffff',
      transparent: true,
      opacity: 1.0,
      depthTest: false,
      depthWrite: false,
      side: THREE.DoubleSide
    });

    super(geometry, material);

    this.texture = texture;
    this.options = { ...options };
  }

  setSize(width, height) {
    this.options.width = width;
    this.options.height = height;

    this.geometry.dispose();
    this.geometry = NineSliceMesh.createGeometry(this.options);
  }

  getWidth() {
    return this.options.width;
  }
  getHeight() {
    return this.options.height;
  }

  static createGeometry({
    width,
    height,

    textureWidth,
    textureHeight,

    left,
    right,
    top,
    bottom,
  }) {
    const geometry = new THREE.BufferGeometry();

    const halfW = width / 2;
    const halfH = height / 2;

    // Geometry coordinates
    const x = [
      -halfW,
      -halfW + left,
      halfW - right,
      halfW,
    ];

    const y = [
      -halfH,
      -halfH + bottom,
      halfH - top,
      halfH,
    ];

    // UV coordinates
    const u = [
      0,
      left / textureWidth,
      (textureWidth - right) / textureWidth,
      1,
    ];

    const v = [
      0,
      bottom / textureHeight,
      (textureHeight - top) / textureHeight,
      1,
    ];

    const positions = [];
    const uvs = [];
    const indices = [];

    let vertexIndex = 0;

    // Build 3x3 grid of quads
    for (let row = 0; row < 3; row++) {
      for (let col = 0; col < 3; col++) {
        const x0 = x[col];
        const x1 = x[col + 1];
        const y0 = y[row];
        const y1 = y[row + 1];

        const u0 = u[col];
        const u1 = u[col + 1];
        const v0 = v[row];
        const v1 = v[row + 1];

        // Four vertices per quad
        positions.push(
          x0, y0, 0,
          x1, y0, 0,
          x1, y1, 0,
          x0, y1, 0,
        );

        uvs.push(
          u0, v0,
          u1, v0,
          u1, v1,
          u0, v1,
        );

        // Two triangles
        indices.push(
          vertexIndex + 0,
          vertexIndex + 1,
          vertexIndex + 2,

          vertexIndex + 0,
          vertexIndex + 2,
          vertexIndex + 3,
        );

        vertexIndex += 4;
      }
    }

    geometry.setAttribute(
      'position',
      new THREE.Float32BufferAttribute(positions, 3)
    );

    geometry.setAttribute(
      'uv',
      new THREE.Float32BufferAttribute(uvs, 2)
    );

    geometry.setIndex(indices);
    geometry.computeVertexNormals()

    geometry.computeBoundingBox();
    geometry.computeBoundingSphere();

    return geometry;
  }
}